import { ChatbotCourseAsset } from "./types";

export type CourseAssetMap = Map<string, ChatbotCourseAsset>;

export function getCourseAssetUrl(asset: ChatbotCourseAsset) {
  return asset.course_url ?? asset.venue_url ?? asset.product_url ?? asset.gymtrainer_url ?? "";
}

export function normalizeCourseAssetUrl(url: string) {
  try {
    const baseUrl = typeof window !== "undefined" ? window.location.origin : "https://trainge.com";
    const parsed = new URL(url, baseUrl);
    parsed.hash = "";
    parsed.search = "";
    return `${parsed.origin}${parsed.pathname.replace(/\/$/, "")}`;
  } catch {
    return url.replace(/[?#].*$/, "").replace(/\/$/, "");
  }
}

export function createCourseAssetMap(assets: ChatbotCourseAsset[]) {
  const map: CourseAssetMap = new Map();

  for (const asset of assets) {
    const url = getCourseAssetUrl(asset);
    if (!url) continue;

    const key = normalizeCourseAssetUrl(url);
    if (!map.has(key)) {
      map.set(key, asset);
    }
  }

  return map;
}

export function mergeCourseAssets(
  existingAssets: ChatbotCourseAsset[],
  incomingAssets: ChatbotCourseAsset[]
) {
  const merged = [...existingAssets];
  const seen = new Set(
    existingAssets
      .map(getCourseAssetUrl)
      .filter(Boolean)
      .map((url) => normalizeCourseAssetUrl(url))
  );

  for (const asset of incomingAssets) {
    const url = getCourseAssetUrl(asset);
    if (!url) continue;

    const key = normalizeCourseAssetUrl(url);
    if (seen.has(key)) continue;
    seen.add(key);
    merged.push(asset);
  }

  return merged;
}

export function findCourseAssetByHref(map: CourseAssetMap, href: string) {
  return map.get(normalizeCourseAssetUrl(href));
}
